<section id="profile-info">
                <button class="btn btn-icon btn-flat-primary mb-1" type="button" (click)="goBack()">
                    <i aria-hidden="true" class="fa fa-arrow-left mr-8px"></i>&nbsp;Back to Universities
                </button>
                <div class="row">
                    <div class="col-lg-12 col-12 order-1 order-lg-2">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="form-group mb-2">
                                    <div class="card">
                                        <div class="card-header">
                                            <h2>Infrastructure</h2>
                                        </div>
                                        <div class="card-body">
                                            <small>Facility</small>
                                            <input class="form-control" [(ngModel)]="facility"/>
                                        </div>
                                        <div class="card-body">
                                            <small>Info</small>
                                            <quill-editor class="university-info" [(ngModel)]="info"
                                                          name="quill-content"></quill-editor>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-primary pull-right" rippleEffect
                                                    (click)="addDetail()">
                                                <i data-feather="submit" class="d-block d-md-none"></i>
                                                <span class="font-weight-bold d-none d-md-block">Add</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="card">
                                    <div class="card-body">
                                        <table class="table table-list">
                                            <thead>
                                            <tr>
                                                <th class="text-center">
                                                    <h6 class="mt-1 mb-1 font-weight-bold">Facility</h6>
                                                </th>
                                                <th class="text-center">
                                                    <h6 class="mt-1 mb-1 font-weight-bold">Info</h6>
                                                </th>
                                                <th class="text-center">
                                                    <h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody *ngIf="infrastructures && infrastructures.length > 0; else noDataToShowWeb">
                                            <tr *ngFor="let infrastructure of infrastructures; let i = index">
                                                <td class="text-center">
                                                    <h6 class="mt-1">{{infrastructure?.facility}}</h6>
                                                </td>
                                                <td class="text-center">
                                                    <div class="mt-1" [innerHTML]="infrastructure.info"></div>
                                                </td>
                                                <td class="text-center">
                                                    <i class="fas fa-trash font-small-4 text-danger cursor-pointer"
                                                       (click)="delete(infrastructure.id)"></i>
                                                </td>
                                            </tr>
                                            </tbody>
                                            <ng-template #noDataToShowWeb>
                                                <tbody>
                                                <tr>
                                                    <td class="text-center" colspan="3">
                                                        <h6 class="mt-1">No data to show</h6>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </ng-template>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
